import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingReportService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report.service';
import { UIRouterModule } from '@uirouter/angular';
import { OnboardingReportStates } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-states';
import { FiOnboardingReportDataService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-data.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiOnboardingReportHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-helper.service';
import { FiOnboardingReportSharedModule } from '@fi-app/fi-onboarding/fi-onboarding-report/shared/fi-onboarding-report-shared.module';
import { FiOnboardingReportDateService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-date.service';
import { FiOnboardingReportParticipantDetailsModule } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-participant-details/fi-onboarding-report-participant-details.module';
import { FiOnboardingReportDashboardModule } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-dashboard/fi-onboarding-report-dashboard.module';
import { FiOnboardingReportDetailsModule } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-details/fi-onboarding-report-details.module';
import { FiOnboardingReportActionsBuilderService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report-actions-builder.service';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild(OnboardingReportStates),
        FiLoadingModule,
        FiOnboardingReportParticipantDetailsModule,
        FiOnboardingReportDashboardModule,
        FiOnboardingReportDetailsModule,
        FiOnboardingReportSharedModule,
    ],
    providers: [
        FiOnboardingReportService,
        FiOnboardingReportDataService,
        FiOnboardingReportHelperService,
        FiOnboardingReportDateService,
        FiOnboardingReportActionsBuilderService,
    ],
})
export class FiOnboardingReportModule {}
